
import Vue from 'vue'
import FavoriteBtn from '@/common/components/FavoriteBtn.vue'

export default Vue.extend({
  components: {
    FavoriteBtn
  },
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    productId: {
      type: String,
      required: true
    },
    estimateItemId: {
      type: String,
      required: true
    },
    disablePrevBtn: {
      type: Boolean,
      required: true
    },
    disableNextBtn: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    prevProduct() {
      this.$emit('prevProduct')
    },
    nextProduct() {
      this.$emit('nextProduct')
    }
  }
})
